import AsyncStorage from "@react-native-async-storage/async-storage";

export type SaveBehavior = "close" | "create_another" | "view_created";

const STORAGE_KEY = "save_behavior_settings";

export const ENTITY_TYPES = [
  "application",
  "client",
  "contact",
  "course",
  "estimate",
  "incident",
  "investigation",
  "invoice",
  "project",
  "shift",
  "timecard",
  "user",
] as const;

export type EntityType = (typeof ENTITY_TYPES)[number];

export const ENTITY_SINGULAR_NAMES: Record<EntityType, string> = {
  application: "Application",
  client: "Client",
  contact: "Contact",
  course: "Course",
  estimate: "Estimate",
  incident: "Incident",
  investigation: "Investigation",
  invoice: "Invoice",
  project: "Project",
  shift: "Shift",
  timecard: "Timecard",
  user: "User",
};

export const SAVE_BEHAVIOR_OPTIONS: { value: SaveBehavior; label: string }[] = [
  { value: "close", label: "Save & Close" },
  { value: "create_another", label: "Save & Create Another" },
  { value: "view_created", label: "Save & View Created" },
];

export async function getSaveBehavior(entity: EntityType): Promise<SaveBehavior> {
  try {
    const settings = await AsyncStorage.getItem(STORAGE_KEY);
    if (settings) {
      const parsed = JSON.parse(settings);
      return parsed[entity] || "close";
    }
  } catch {}
  return "close";
}

export async function setSaveBehavior(entity: EntityType, behavior: SaveBehavior): Promise<void> {
  const settings = await AsyncStorage.getItem(STORAGE_KEY);
  const parsed = settings ? JSON.parse(settings) : {};
  parsed[entity] = behavior;
  await AsyncStorage.setItem(STORAGE_KEY, JSON.stringify(parsed));
}

export async function getAllSaveBehaviors(): Promise<Record<EntityType, SaveBehavior>> {
  try {
    const settings = await AsyncStorage.getItem(STORAGE_KEY);
    const parsed = settings ? JSON.parse(settings) : {};
    const result: Record<string, SaveBehavior> = {};
    for (const entity of ENTITY_TYPES) {
      result[entity] = parsed[entity] || "close";
    }
    return result as Record<EntityType, SaveBehavior>;
  } catch {
    const result: Record<string, SaveBehavior> = {};
    for (const entity of ENTITY_TYPES) {
      result[entity] = "close";
    }
    return result as Record<EntityType, SaveBehavior>;
  }
}
